import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class JsonAdapterService {

  constructor() { }

  stringify<T>(object: T): string | T {
    return typeof object === 'string' ? object : JSON.stringify(object);
  }

  jsonify<T>(object: any): T {
    return typeof object === 'string' ? JSON.parse(object) : object;
  }

  public static staticJsonify<T>(object: any): T {
    return typeof object === 'string' ? JSON.parse(object) : object;
  }
}
